import React, { useEffect, useState } from "react";
import "../../styles/admin/createPreference.scss";
import CloseIcon from "@mui/icons-material/Close";
import { DeleteIcon, AddCircleIcon } from "../../icons";
import DropdownSelect from "../common/DropdownSelect";

const CreatePreference = ({
  isOpen,
  onClose,
  onSave,
  intialData,
  isViewStatus,
  setIsViewable,
}) => {
  const [preferenceName, setPreferenceName] = useState("");
  const [contentData, setContentData] = useState([
    {
      sequence: 1,
      type: null,
      question: "",
      examples: "",
      options: [],
    },
  ]);
  const [error, setError] = useState({});

  const handleClickAddContent = () => {
    const newIndex = contentData?.length || 0;

    setContentData((prev) => [
      ...(Array.isArray(prev) ? prev : []),
      {
        sequence: newIndex + 1,
        type: null,
        question: "",
        examples: "",
        options: [],
      },
    ]);
  };

  const handleRemoveContent = (idx) => {
    setContentData((prev) => {
      const next = [...prev.slice(0, idx), ...prev.slice(idx + 1)];
      return next.map((item, i) => ({ ...item, sequence: i + 1 }));
    });
  };

  const addOption = (cIdx) => {
    setContentData((prev) => {
      const next = [...prev];
      const opts = Array.isArray(next[cIdx]?.options) ? next[cIdx].options : [];
      next[cIdx] = { ...next[cIdx], options: [...opts, ""] };
      return next;
    });
  };

  const updateOption = (cIdx, oIdx, val) => {
    setContentData((prev) => {
      const next = [...prev];
      const opts = Array.isArray(next[cIdx]?.options)
        ? [...next[cIdx].options]
        : [];
      opts[oIdx] = val;
      next[cIdx] = { ...next[cIdx], options: opts };
      return next;
    });
  };

  const removeOption = (cIdx, oIdx) => {
    setContentData((prev) => {
      const next = [...prev];
      const opts = Array.isArray(next[cIdx]?.options)
        ? [...next[cIdx].options]
        : [];
      opts.splice(oIdx, 1);
      next[cIdx] = { ...next[cIdx], options: opts };
      return next;
    });
  };

  const validateContent = () => {
    let hasError = false;

    setError({});
    const newErrors = {};

    contentData.forEach((d, index) => {
      if (!d.question?.trim()) {
        newErrors[index] = {
          ...(newErrors[index] || {}),
          question: "Question required",
        };
        hasError = true;
      }

      if (d.type?.value === "fillups") {
        if (!d.examples?.trim()) {
          newErrors[index] = {
            ...(newErrors[index] || {}),
            examples: "Examples required",
          };
          hasError = true;
        }
      }

      if (d.type?.value === "mcq") {
        if (!Array.isArray(d.options) || d.options.some((o) => !o.trim())) {
          newErrors[index] = {
            ...(newErrors[index] || {}),
            option: "All options required",
          };
          hasError = true;
        }
      }
    });

    setError(newErrors);
    return !hasError;
  };
  const handleSubmit = () => {
    if (!validateContent()) return;

    const payload = {
      name: preferenceName?.trim(),
      content: (contentData || []).map((c, i) => {
        const base = {
          sequence: i + 1,
          question: c.question?.trim() || "",
          type: c?.type?.value || "",
        };
        if (base.type === "fillups") {
          return { ...base, examples: c.examples?.trim() || "" };
        }
        if (base.type === "mcq") {
          const options = Array.isArray(c.options)
            ? c.options.map((o) => (o || "").trim()).filter((o) => o)
            : [];
          return { ...base, options };
        }
        return base;
      }),
    };

    if (typeof onSave === "function") onSave(payload);
    else console.log("Preference payload:", payload);
  };

  const handleClose = () => {
    setContentData([]);
    onClose();
  };

  useEffect(() => {
    const updatePreference = intialData?.content?.map((data) => {
      const d = {
        ...data,
        type:
          data.type === "mcq"
            ? { value: "mcq", label: "MCQ" }
            : { value: "fillups", label: "Fill ups" },
      };
      return d;
    });
    setPreferenceName(intialData?.name);
    console.log(updatePreference);
    if (updatePreference?.length > 0) {
      setContentData(updatePreference);
    } else {
      setContentData([
        {
          sequence: 1,
          type: null,
          question: "",
          examples: "",
          options: [],
        },
      ]);
    }
  }, [intialData]);

  if (!isOpen) return null;

  return (
    <div className="preference-popup-overlay-container">
      <div className="preference-popup-main-container">
        <div className="preference-popup-main-info">
          <div className="preference-popup-form-header">
            <h2>{intialData?.length > 0 ? "Edit" : "Create"} Preference</h2>
            <button
              className="preference-popup-close-button"
              onClick={handleClose}
              aria-label="Close"
            >
              <CloseIcon fontSize="small" />
            </button>
          </div>
          <div className="preference-popup-body-container">
            <div className="preference-popup-input-group">
              <label className="preference-popup-input-label">Name</label>
              <input
                type="text"
                name="name"
                className="preference-popup-text-input"
                placeholder="Enter preference name"
                value={preferenceName || ""}
                onChange={(event) => {
                  setPreferenceName(event.target.value);
                }}
                disabled={isViewStatus}
              />
            </div>
            <div className="preference-popup-question-generate-container">
              <div className="preference-popup-question-generate-header">
                <h3>Content</h3>
              </div>
              <div className="preference-popup-question-generate-info">
                {contentData?.map((content, index) => (
                  <div
                    key={`content-${index}`}
                    className="preference-popup-question-explanation-container"
                  >
                    <div className="preference-popup-question-row">
                      <DropdownSelect
                        disable={isViewStatus}
                        inputId={`question-type-${index}`}
                        options={[
                          { value: "mcq", label: "MCQ" },
                          { value: "fillups", label: "Fill ups" },
                        ]}
                        value={content?.type}
                        onChange={(vals) =>
                          setContentData((prev) => {
                            const updated = [...prev];
                            updated[index] = {
                              ...updated[index],
                              type: vals,
                              examples:
                                vals?.value === "fillups"
                                  ? updated[index].examples || ""
                                  : "",
                              options:
                                vals?.value === "mcq"
                                  ? Array.isArray(updated[index].options) &&
                                    updated[index].options?.length
                                    ? updated[index].options
                                    : ["", ""]
                                  : [],
                            };
                            return updated;
                          })
                        }
                        placeholder="Select type"
                        searchable
                      />
                      {!isViewStatus && (
                        <div className="preference-popup-inline-dropdown-action">
                          <button
                            type="button"
                            className={`preference-popup-inline-delete ${
                              contentData?.length < 2 ? "disable-btn" : ""
                            }`}
                            onClick={() => handleRemoveContent(index)}
                            aria-label="Remove question"
                            disabled={contentData?.length < 2}
                          >
                            <DeleteIcon className="inline-delete-icon" />
                          </button>
                          <div>
                            {contentData?.length - 1 === index && (
                              <button
                                type="button"
                                className="preference-popup-action-btn-container"
                                onClick={() => handleClickAddContent(index)}
                                aria-label="Remove question"
                              >
                                <AddCircleIcon className="inline-add-icon" />
                              </button>
                            )}
                          </div>
                        </div>
                      )}
                    </div>

                    {content?.type?.value === "fillups" && (
                      <div className="preference-popup-question-explanation-info">
                        <div>
                          <label className="preference-popup-question-label">
                            Question {index + 1}
                          </label>
                          <input
                            className="preference-popup-question-input"
                            value={content?.question}
                            onChange={(e) =>
                              setContentData((prev) => {
                                const updated = [...prev];
                                updated[index] = {
                                  ...updated[index],
                                  question: e.target.value,
                                };
                                return updated;
                              })
                            }
                            disabled={isViewStatus}
                          />
                        </div>
                        <div>
                          <label className="preference-popup-question-label">
                            Explanation
                          </label>
                          <textarea
                            className="preference-popup-question-textarea"
                            rows={3}
                            value={content?.examples}
                            onChange={(e) =>
                              setContentData((prev) => {
                                const updated = [...prev];
                                updated[index] = {
                                  ...updated[index],
                                  examples: e.target.value,
                                };
                                return updated;
                              })
                            }
                            disabled={isViewStatus}
                          />
                        </div>
                      </div>
                    )}
                    {content?.type?.value === "mcq" && (
                      <div className="preference-popup-question-explanation-info">
                        <div>
                          <label className="preference-popup-question-label">
                            Question {index + 1}
                          </label>
                          <input
                            className="preference-popup-question-input"
                            value={content?.question}
                            onChange={(e) =>
                              setContentData((prev) => {
                                const updated = [...prev];
                                updated[index] = {
                                  ...updated[index],
                                  question: e.target.value,
                                };
                                return updated;
                              })
                            }
                            disabled={isViewStatus}
                          />
                        </div>
                        <div>
                          <label className="preference-popup-question-label">
                            Options
                          </label>
                          <div className="preference-popup-options">
                            {(content.options || []).map((opt, oIdx) => (
                              <div
                                className="preference-popup-option-row"
                                key={`opt-${index}-${oIdx}`}
                              >
                                <input
                                  className="preference-popup-question-input"
                                  value={opt}
                                  placeholder={`Option ${oIdx + 1}`}
                                  onChange={(e) =>
                                    updateOption(index, oIdx, e.target.value)
                                  }
                                  disabled={isViewStatus}
                                />
                                {!isViewStatus && (
                                  <div className="preference-popup-inline-option-action">
                                    <button
                                      type="button"
                                      className={`preference-popup-inline-delete ${
                                        content?.options?.length < 3
                                          ? "disable-btn"
                                          : ""
                                      }`}
                                      onClick={() => removeOption(index, oIdx)}
                                      aria-label="Remove option"
                                      disabled={content?.options?.length === 0}
                                    >
                                      <DeleteIcon className="inline-delete-icon" />
                                    </button>
                                    {content?.options?.length - 1 === oIdx && (
                                      <button
                                        type="button"
                                        className="preference-popup-inline-add"
                                        onClick={() => addOption(index)}
                                      >
                                        <AddCircleIcon className="inline-add-icon" />
                                      </button>
                                    )}
                                  </div>
                                )}
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                ))}
                {contentData?.length === 0 && (
                  <div className="preference-popup-empty">
                    No questions added yet.
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="preference-popup-action-container">
            <div className="preference-popup-footer">
              {!isViewStatus && (
                <>
                  <button
                    className="preference-popup-primary"
                    onClick={handleSubmit}
                    disabled={
                      !preferenceName?.trim() || contentData?.length === 0
                    }
                  >
                    Save
                  </button>
                </>
              )}
              {isViewStatus && (
                <button
                  className="preference-popup-primary"
                  onClick={() => {
                    setIsViewable(false);
                  }}
                >
                  Edit
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreatePreference;
